export default __webpack_public_path__ + "static/media/arquivos.5881ec90.svg";